import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'

import InvoiseTable from '../Tables/InvoiceTable';
import ContractTable from '../Tables/ContractTable';

@inject('userStore')

@observer
class ContractsAndInvoices extends Component {

  componentWillMount() {
  }

  render() {
    const { contracts, invoices } = this.props.userStore;

    return (
      <div>
        <Container>
          <Heading>Rechnungen</Heading>

          <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 10 }}></div>

          <div style={{ color: 'black', margin: 15 }} className={'bootstrap-table users'}>
            <InvoiseTable data={ invoices } hide={["company"]}/>
          </div>
        </Container>

        <Container>
          <Heading>Verträge</Heading>

          <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 10 }}></div>

          <div style={{ color: 'black', margin: 15 }} className={'bootstrap-table users'}>
            <ContractTable data={ contracts } hide={["company"]}/>
          </div>
        </Container>
      </div>
    )
  }
}

export default ContractsAndInvoices

const Container = styled.div `
  color: black;
  margin: 15px;
  padding: 15px;
  border: 1px solid rgb(0,0,0,15%);
  background-color: white;
  margin-top: 45px;
  @media (max-width: 990px) {
      margin-top: 0px !important;
      margin: 0px;
      padding: 0px;
  }
`

const Heading = styled.h2 `
  font-size: 20px;
  color: #212D3D;
  padding-left: 15px;
  @media (max-width: 500px) {
    font-size: 20px;
  }
  color: #000000;
  text-transform: uppercase;
`



// WEBPACK FOOTER //
// /src/components/internal/ContractsAndInvoices.js